<template>
  <div>
    <div id="header-container" class="pl-5">
      <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
      <div class="pt-4 text-white">
        <h3 class="text-white">{{ $t('Change Password') }}</h3>
        <!-- <span class="fz-16 fw-400">Lorem ipsum dolor, sit amet consectetur adipisicing elit.</span> -->
      </div>
    </div>
    <b-container fluid class="pb-5 transaction-section">
      <div id="body-container">
        <b-row>
          <b-col xl="12" class="pt-3">
              <div class="form-group mb-2 mt-3">
                <div class="d-flex align-items-center">
                  <label class="mb-0">{{isFirstTime=="forget-password"?$t('OTP'):(isFirstTime=="false"?$t('Old Password'):$t('First Time Password'))}}</label>
                  <div v-if="isFirstTime!='false' && isFirstTime !='forget-password'" class="position-relative">
                    <img :src="`${publicPath}/img/rcp/icon/info-circle.png`" class="btn-tooltip mb-1 mx-2" @click="toggleTooltip"/>
                    <div v-if="isTooltip" class="absolute tooltip-info2 fz-14 fw-500">
                      <div class="title">Please refer the password<br>sent to your email</div>
                    </div>
                  </div>
                </div>
                <b-input-group class="input-no-border">
                  <b-form-input v-model="oldPassword" :type="show_oldPassword?'text':'password'" :placeholder="isFirstTime=='forget-password'?$t('OTP'):(isFirstTime=='false'?$t('Old Password'):$t('FTP'))" @keydown="onChange('oldPassword')"></b-form-input>
                  <template #append>
                    <button class="btn-action" @click="toggleShow('oldPassword')">
                      <i class="far pl-2 pr-2" :class="{ 'fa-eye-slash': show_oldPassword, 'fa-eye': !show_oldPassword }"></i>
                    </button>
                  </template>
                </b-input-group>
                <div v-if="error['oldPassword']" class="invalid-feedback d-block mb-3">
                  {{error['oldPassword']}}
                </div>
              </div>

              <div class="form-group mb-2 mt-3">
                <label>{{ $t('New Password') }}</label>
                <b-input-group class="input-no-border">
                  <b-form-input v-model="newPassword" :type="show_newPassword?'text':'password'" :placeholder="$t('New Password')" @keydown="onChange('newPassword')"></b-form-input>
                  <template #append>
                    <button class="btn-action" @click="toggleShow('newPassword')">
                      <i class="far pl-2 pr-2" :class="{ 'fa-eye-slash': show_newPassword, 'fa-eye': !show_newPassword }"></i>
                    </button>
                  </template>
                </b-input-group>
                <div v-if="error['newPassword']" class="invalid-feedback d-block mb-3">
                  {{$t(error['newPassword'])}}
                </div>
              </div>

              <div class="form-group mb-2 mt-3">
                <label>{{ $t('Confirm New Password') }}</label>
                <b-input-group class="input-no-border">
                  <b-form-input v-model="confirmPassword" :type="show_confirmPassword?'text':'password'" :placeholder="$t('Confirm New Password')" @keydown="onChange('confirmPassword')"></b-form-input>
                  <template #append>
                    <button class="btn-action" @click="toggleShow('confirmPassword')">
                      <i class="far pl-2 pr-2" :class="{ 'fa-eye-slash': show_confirmPassword, 'fa-eye': !show_confirmPassword }"></i>
                    </button>
                  </template>
                </b-input-group>
                <div v-if="error['confirmPassword']" class="invalid-feedback d-block mb-3">
                  {{$t(error['confirmPassword'])}}
                </div>
              </div>

              <div class="button-wrapper text-right mt-4">
                <button type="button" class="btn btn-primary rounded-pill pl-5 pr-5" @click="changePassword">{{ $t('Save') }}</button>
              </div>
              
          </b-col>
        </b-row>
      </div>
      <LoaderComponent v-if="isLoading"></LoaderComponent>
    </b-container>
  </div>
</template>
<script>
  import Vue from 'vue';
  import Auth from "@/services/Auth";
  import LoaderComponent from "@/components/LoaderComponent";

  export default {
    name: 'change-password',
    data() {
      return {
        isFirstTime            :"false",
        oldPassword            :'',
        newPassword            :'',
        confirmPassword        :'',
        isTooltip              : false,
        show_oldPassword       : false,
        show_newPassword       : false,
        show_confirmPassword   : false,
        isLoading              : false,
        publicPath             : process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        error:{
          oldPassword      :'',
          newPassword      :'',
          confirmPassword   :''
        }
      };
    },
    components: {
      LoaderComponent
    },
    methods: {
      toggleTooltip(){
        this.isTooltip = !this.isTooltip;
      },
      toggleShow(name) {
        this["show_"+name] = !this["show_"+name];
      },
      onChange(name){
        this.error[name]="";
      },
      getMessage: function (key) {
        return this.$t(key)
      },
      resetError(){
        Object.keys(this.error).forEach((key)=>{
          this.error[key] = '';
        });
      },
      changePassword(){
        this.resetError();
        this.isLoading = true;
        Auth.updatePassword({
          oldPassword:this.oldPassword,
          newPassword:this.newPassword,
          confirmPassword:this.confirmPassword
        }).then(response=>{
          if(response.status == 200){
            this.isLoading = false;
            if(response.data.success == true){
              this.$swal({
                icon: 'success',
                title: this.getMessage('Success'),
                showConfirmButton: true,
              }).then((result) => {
                localStorage.setItem("isFirstTime",false);
                window.location.reload(); 
              });
            }
            else{
              this.$notify({
                type: 'warn',
                text: response.data.message
              })
            }
          }
        }).catch(err => {
          this.isLoading = false;
          this.checkError(err);
        });
      },
      checkError(err){        
        try{
          const response = err.response;
          if(response.status == 400){
            Object.keys(response.data.data).forEach((key) => {
              this.error[key] = response.data.data[key][0];
            });
          }
          else if(response.status == 401 && response.data.name == "Unauthorized"){
                  localStorage.removeItem("token");
                  localStorage.removeItem("member");
                  localStorage.removeItem("isFirstTime");
                  this.$router.push({ 
                    path: '/login', 
                  });
                }
          else{
            var msg = (response.data)?response.data.message:err.message;
            this.$notify({
              type: 'warn',
              text: msg
            })
          }
        }catch(e){
          console.log(err);
        }
      }
    },
    mounted(){
      this.isFirstTime = localStorage.getItem("isFirstTime");
    }
  };
</script>
<style></style>

<style>
h5{
  font-size: 18px;
  font-weight: 600;
  color: #192534;
}
.btn-secondary{
    border: 1px solid #D1D5DB !important;
    background: #FFF !important;
    color: #192534 !important;
    box-shadow: unset !important;
    border-radius: 10px !important;
}
.btn-orange{
  width: auto !important;
}
.bg-peach{
    background-color: #FFFBE7;
}
.disable-amount{
  border: unset !important;
  text-align: left !important;
}
input[type=checkbox] {
    width: 20px;
    height: 20px;
    background: #fff;
    border-radius: 5px;
    font-size: 16px;
}
.modal-body{
  padding: 1.5rem 0 !important;
}
.modal-content{
  overflow-x: hidden !important;
}
.btn-tooltip{
  cursor: pointer;
  width: 18px;
}
.text-nowrap{
  white-space: nowrap;
}
.tooltip-info2{
  background-color: #1F2A37;
  width: 225px;
  word-break: break-all;
  padding: 10px;
  border-radius: 4px;
  position: absolute;
  top: -5px;
  -webkit-transform: translateY(-100%);
  transform: translateY(-100%);
  left:0;
}
.tooltip-info2::after{
    content: ' ';
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #1f2a37;
    position: absolute;
    left: 7px;
    bottom: -7px;
}
.tooltip-info2 .title{
  color: #fff;
}
.tooltip-info2 .desc{
  color: #9CA3AF;
}
.description-information{
  color: #696F8C;
}
.modal-backdrop{
  background: rgba(0,0,0,.8);
}
.fz-20{
font-size: 18px !important;
}
.fz-26{
    font-size: 22px !important;
}
.fz-36{
    color: #192534;
    font-size: 31px !important;
}
</style>